"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customer = exports.handleUserGroups = exports.handleMembers = exports.handleSalesman = exports.handleRegion = exports.handleWizard = exports.handleYtj = exports.handleList = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
// wizard
const listReducer = require("./list");
// wizard
const wizardReducer = require("./wizard");
// region
const regionReducer = require("./region");
// salesman
const salesmanReducer = require("./salesman");
// company memebers
const membersReducer = require("./members");
// company user groups
const userGroupsReducer = require("./userGroups");
// ytj
const ytj = require("./ytj");
const _dashboardReducer = require("../../modules/dashboard/reducers");
const dashboardReducer = _dashboardReducer.default('customer');
//#endregion
//#region INITIAL STATE
exports.initialState = {
    list: Object.assign({}, listReducer.initialState),
    wizard: Object.assign({}, wizardReducer.initialState),
    ytj: Object.assign({}, ytj.initialState),
    region: Object.assign({}, regionReducer.initialState),
    salesman: Object.assign({}, salesmanReducer.initialState),
    members: Object.assign({}, membersReducer.initialState),
    userGroups: Object.assign({}, userGroupsReducer.initialState),
    dashboard: Object.assign({}, dashboardReducer.initialState)
};
//#endregion
//#region LENS
const listLens = monocle.Lens.fromProp('list');
const wizardLens = monocle.Lens.fromProp('wizard');
const ytjLens = monocle.Lens.fromProp('ytj');
const regionLens = monocle.Lens.fromProp('region');
const salesmanLens = monocle.Lens.fromProp('salesman');
const membersLens = monocle.Lens.fromProp('members');
const userGroupsLens = monocle.Lens.fromProp('userGroups');
const dashboardLens = monocle.Lens.fromProp('dashboard');
//#endregion
//#region REDUCER
// List
const handleList = (action) => (state) => {
    const fn = listReducer.methods[action.type];
    if (fn) {
        return listLens.modify((listState) => fn(listState, action))(state);
    }
    return state;
};
exports.handleList = handleList;
// YTJ
const handleYtj = (action) => (state) => {
    const fn = ytj.methods[action.type];
    if (fn) {
        return ytjLens.modify((ytjState) => fn(ytjState, action))(state);
    }
    return state;
};
exports.handleYtj = handleYtj;
// Wizard
const handleWizard = (action) => (state) => {
    const fn = wizardReducer.methods[action.type];
    if (fn) {
        return wizardLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
exports.handleWizard = handleWizard;
// Region
const handleRegion = (action) => (state) => {
    const fn = regionReducer.methods[action.type];
    if (fn) {
        return regionLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
exports.handleRegion = handleRegion;
// Salesman
const handleSalesman = (action) => (state) => {
    const fn = salesmanReducer.methods[action.type];
    if (fn) {
        return salesmanLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
exports.handleSalesman = handleSalesman;
// Company members
const handleMembers = (action) => (state) => membersLens.modify((s) => membersReducer.members(s, action))(state);
exports.handleMembers = handleMembers;
// Company User Groups
const handleUserGroups = (action) => (state) => userGroupsLens.modify((s) => userGroupsReducer.userGroups(s, action))(state);
exports.handleUserGroups = handleUserGroups;
const handleDashboard = (action) => (state) => {
    const fn = dashboardReducer.methods[action.type];
    if (fn) {
        return dashboardLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
// Reducer
const customer = (state = exports.initialState, action) => {
    return fp.function.compose((0, exports.handleList)(action), (0, exports.handleWizard)(action), (0, exports.handleYtj)(action), (0, exports.handleRegion)(action), (0, exports.handleSalesman)(action), (0, exports.handleMembers)(action), (0, exports.handleUserGroups)(action), handleDashboard(action))(state);
};
exports.customer = customer;
//#endregion
//# sourceMappingURL=index.js.map